import React, { Component } from 'react'
import { connect } from 'react-redux'
import TeamFeed from './TeamFeed'
import { getTeam, removeTeamFromLoaded } from '../../actions'

class MyTeam extends Component {
  componentWillMount () {
    const id = this.props.match.params.id
    const team = this.props.teams.find(t => t.id === id)
    !team && this.props.dispatch(getTeam(id))
  }

  componentWillUnmount () {
    const id = this.props.match.params.id
    const team = this.props.teams.find(t => t.id === id)
    const owner = team && this.props.players.find(p => p.id === team.owner)
    if (owner && !owner.location.includes(this.props.location)) {
      this.props.dispatch(removeTeamFromLoaded(id))
    }
  }

  render () {
    const id = this.props.match.params.id
    const team = this.props.teams.find(t => t.id === id)

    return (
      <TeamFeed {...team} />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    teams: state.team.teams,
    players: state.participants,
    location: state.auth.user.location
  }
}

export default connect(mapStateToProps)(MyTeam)



// WEBPACK FOOTER //
// ./src/screens/team/TeamPage.js